import type { Contract } from "@/lib/api";

interface SummaryCardsProps {
  contracts: Contract[];
}

function daysFromNow(dateStr: string): number {
  const diff = new Date(dateStr).getTime() - Date.now();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export default function SummaryCards({ contracts }: SummaryCardsProps) {
  const tiers = [
    { label: "Expiring in 30 Days", days: 30, icon: "ri-timer-flash-line", iconBg: "bg-foreground-100", iconColor: "text-foreground-500" },
    { label: "Expiring in 60 Days", days: 60, icon: "ri-timer-line", iconBg: "bg-accent-50", iconColor: "text-accent-500" },
    { label: "Expiring in 90 Days", days: 90, icon: "ri-calendar-check-line", iconBg: "bg-primary-50", iconColor: "text-primary-500" },
    { label: "Expiring in 180 Days", days: 180, icon: "ri-calendar-2-line", iconBg: "bg-background-100", iconColor: "text-foreground-500" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {tiers.map((tier) => {
        const count = contracts.filter((c) => {
          const d = daysFromNow(c.end_date);
          return d > 0 && d <= tier.days;
        }).length;
        return (
          <div key={tier.days} className="bg-white rounded-lg border border-background-200 p-4 md:p-5 hover:shadow-sm transition-shadow">
            <div className="flex items-center justify-between mb-3">
              <div className={`w-9 h-9 rounded-lg ${tier.iconBg} flex items-center justify-center`}>
                <i className={`${tier.icon} ${tier.iconColor} text-base`}></i>
              </div>
              <span className="text-foreground-900 text-2xl md:text-3xl font-bold">{count}</span>
            </div>
            <p className="text-foreground-600 text-sm font-medium">{tier.label}</p>
          </div>
        );
      })}
    </div>
  );
}
